import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Course from "./components/pages/admin/courses/Course";
import CourseDetail from "./components/pages/admin/courses/CourseDetail";
import AddCourseApplicant from "./components/pages/admin/courses/AddCourseApplicant";
import UpdateCourseApplicant from "./components/pages/admin/courses/UpdateCourseApplicant";
import CourseApplicantDetail from "./components/pages/admin/courses/CourseApplicantDetail";
import CancelCourseApplicant from "./components/pages/admin/courses/CancelCourseApplicant";
import AdminUser from "./components/pages/admin/admin-users/AdminUser";
import AdminUserRegister from "./components/pages/admin/admin-users/AdminUserRegister";
import StudentUser from "./components/pages/admin/student-users/StudentUser";
import StudentDetailEdit from "./components/pages/admin/student-users/StudentDetailEdit";
import StudentDetail from "./components/pages/admin/student-users/StudentDetail";
import StudentApproval from "./components/pages/admin/student-users/StudentApproval";
import DuplicateStudent from "./components/pages/admin/student-users/DuplicateStudent";
import Notification from "./components/pages/admin/notification/Notification";
import NoticeDetailEdit from "./components/pages/admin/notification/NotificationDetailEdit";
import NoticeDetail from "./components/pages/admin/notification/NotificationDetail";
import NoticeCategory from "./components/pages/admin/notification/NoticeCategory";
import CategoryEdit from "./components/pages/admin/notification/CategoryEdit";
import NewsList from "./components/pages/mypage/news/NewsList";
import NewsDetail from "./components/pages/mypage/news/NewsDetail";
import UpdateContacts from "./components/pages/mypage/user/UpdateContacts";
import UpdatePassword from "./components/pages/mypage/user/UpdatePassword";
import User from "./components/pages/mypage/user/User";
import SearchAcceptingCourseList from "./components/pages/mypage/course/SearchAcceptingCourseList";
import SearchBeforeCourseList from "./components/pages/mypage/course/SearchBeforeCourseList";
import AppliedCourseList from "./components/pages/mypage/course/AppliedCourseList";
import AttendedCourseList from "./components/pages/mypage/course/AttendedCourseList";
import CourseApplication from "./components/pages/mypage/course/CourseApplication";
import CourseCancel from "./components/pages/mypage/course/CourseCancel";
import PageNotFound from "./components/pages/error/PageNotFound";
import Inquiry from "./components/pages/mypage/inquiry/Inquiry";
// import "./App.scss";
import { default as AdminLayout } from "./components/layout/admin/Layout";
import { default as AdminTop } from "./components/pages/admin/top/Top";
import { default as AdminLogin } from "./components/pages/admin/login/Login";

import { default as MyPageLogin } from "./components/pages/mypage/login/Login";
import { default as Password } from "./components/pages/mypage/login/Password";
import { default as PasswordSetting } from "./components/pages/mypage/login/PasswordSetting";
import { default as Admission } from "./components/pages/mypage/admission/Admission";
import { default as MyPageLayout } from "./components/layout/mypage/Layout";
import { default as MyPageTop } from "./components/pages/mypage/top/Top";
import { default as MyPageCourseDetail } from "./components/pages/mypage/course/CourseDetail";

import { AuthProvider } from "./contexts/AuthContext";
import {
  AdminProtectedRoute,
  MyPageProtectedRoute,
} from "./contexts/ProtectedRoute";
import Error404Admin from "./components/pages/admin/error/404";
import ErrorAPIAdmin from "./components/pages/admin/error/api";
import Error404Mypage from "./components/pages/mypage/error/404";
import ErrorAPIMypage from "./components/pages/mypage/error/api";

import Error from "./components/pages/error/Error";
const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* 管理画面 */}
          <Route exact path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route index element={<Navigate replace to="top" />} />
            <Route path="top" element={<AdminTop />} />

            <Route exact path="student">
              <Route index element={<StudentUser />} />
              <Route path="detail/:userId" element={<StudentDetail />} />
              <Route
                path="detail/:mode/:userId"
                element={<StudentDetailEdit />}
              />
              <Route path="approval/:userId" element={<StudentApproval />} />
              <Route path="duplicate/:userId" element={<DuplicateStudent />} />
            </Route>

            <Route exact path="course">
              <Route index element={<Course />} />
              <Route path="detail/:id/:type" element={<CourseDetail />} />
              <Route path="detail/add/:id" element={<AddCourseApplicant />} />
              <Route
                path="detail/applicant/:id/:userId"
                element={<CourseApplicantDetail />}
              />
              <Route
                path="detail/applicant/cancel/:id/:userId"
                element={<CancelCourseApplicant />}
              />
              <Route
                path="detail/applicant/update/:id/:userId"
                element={<UpdateCourseApplicant />}
              />
            </Route>

            <Route exact path="admin">
              <Route index element={<AdminUser />} />
              <Route
                path="register/:mode/:id"
                element={<AdminUserRegister />}
              />
            </Route>

            <Route exact path="notification">
              <Route index element={<Notification />} />
              <Route
                path="detail/:mode/:noticeId"
                element={<NoticeDetailEdit />}
              />
              <Route path="detail/:noticeId" element={<NoticeDetail />} />
              <Route exact path="category">
                <Route index element={<NoticeCategory />} />
                <Route path="edit/:mode/:id" element={<CategoryEdit />} />
              </Route>
            </Route>
            {/* エラーページ */}
            <Route path="apierror" element={<ErrorAPIAdmin />} />
            <Route path="*" element={<Error404Admin />} />
          </Route>

          {/* マイページ */}
          <Route exact path="/mypage/login" element={<MyPageLogin />} />
          <Route exact path="/mypage/password" element={<Password />} />
          <Route
            exact
            path="/mypage/passwordsetting/:token"
            element={<PasswordSetting />}
          />
          <Route exact path="/mypage/admission" element={<Admission />} />
          <Route exact path="/mypage/inquiry" element={<Inquiry />} />
          <Route
            path="/mypage"
            element={
              <MyPageProtectedRoute>
                <MyPageLayout />
              </MyPageProtectedRoute>
            }
          >
            <Route index element={<Navigate replace to="top" />} />
            <Route path="top" element={<MyPageTop />} />
            <Route exact path="news">
              <Route index element={<NewsList />} />
              <Route path=":type" element={<NewsList />} />
              <Route path="detail/:id" element={<NewsDetail />} />
            </Route>
            <Route exact path="user">
              <Route index element={<User />} />
              <Route path="update" element={<UpdateContacts />} />
              <Route path="password" element={<UpdatePassword />} />
            </Route>
            <Route exact path="course">
              <Route exact path="search">
                <Route
                  path="accepting"
                  element={<SearchAcceptingCourseList />}
                />
                <Route path="before" element={<SearchBeforeCourseList />} />
              </Route>
              <Route path="applied" element={<AppliedCourseList />} />
              <Route path="attended" element={<AttendedCourseList />} />
              <Route path="detail/:id" element={<MyPageCourseDetail />} />
              <Route path="applicant/:id" element={<CourseApplication />} />
              <Route path="cancel/:id" element={<CourseCancel />} />
            </Route>
            {/* エラーページ */}
            <Route path="apierror" element={<ErrorAPIMypage />} />
            <Route path="notfound" element={<Error404Mypage />} />
          </Route>

          {/* エラー */}
          <Route path="error" element={<Error />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
